import { Controller } from '@hotwired/stimulus'
import autosize from '@github/textarea-autosize'

export default class extends Controller {
  static targets = ['textarea']

  initialize() {
    this.subscriptions = new Map()
    this.resizeTextareas = this.resizeTextareas.bind(this)
  }

  connect() {
    this.modal = this.element.closest('.modal')
    this.modal?.addEventListener('shown.bs.modal', this.resizeTextareas)
  }

  disconnect() {
    this.modal?.removeEventListener('shown.bs.modal', this.resizeTextareas)
  }

  textareaTargetConnected(textarea) {
    this.subscriptions.set(textarea, autosize(textarea))
  }

  textareaTargetDisconnected(textarea) {
    this.subscriptions.get(textarea)?.unsubscribe()
    this.subscriptions.delete(textarea)
  }

  resizeTextareas() {
    this.textareaTargets.forEach(textarea =>
      textarea.dispatchEvent(new Event('change'))
    )
  }
}
